import { lazy, Suspense } from 'react';

// Lazy load the FirebaseMessagingProvider to avoid including firestore-full in initial bundle
const FirebaseMessagingProvider = lazy(() => 
  import('@/contexts/FirebaseMessagingContext').then(module => ({
    default: module.FirebaseMessagingProvider
  }))
);

/**
 * Lazy-loaded wrapper for FirebaseMessagingProvider
 * This prevents firestore-full from being included in the initial bundle
 */
export const LazyFirebaseMessagingProvider = ({ children }) => (
  <Suspense fallback={null}>
    <FirebaseMessagingProvider>
      {children}
    </FirebaseMessagingProvider>
  </Suspense>
);

export default LazyFirebaseMessagingProvider;